export const MENU = {
    HOME: '',
    DOCUMENTS: 'documents',
    INSPECTIONS: 'inspections',
}